import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Build, Lock } from '@material-ui/icons';

import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SecuritySettings from './SecuritySettings';
import SystemSettings from './SystemSettings';

const useStyles = makeStyles((theme)=> ({
    settingContainer: {
        display: 'flex', 
        flexDirection: 'row'
    }
}))

const settingsConfig = [
    {
        id: 1,
        icon: <Build />,
        primary: "system",
        secondary: null,
        access_level: null,
        content: <SystemSettings />
    },
    {
        id: 2,
        icon: <Lock />,
        primary: "security",
        secondary: null,
        access_level: null,
        content: <SecuritySettings />
    }
]

function Settings(props){
    const {configs} = props
    const {t} = useTranslation('common')
    const classes = useStyles();

    const [selectedCategory, setSelectedCategory] = useState(1);

    function getContent(id){
        let config = _.find(settingsConfig, {'id': id})
        return (
            <div>
                <Typography style={{marginLeft: 16, marginTop: 16}}>{t(config.primary)}</Typography>
                {config.content}
            </div>
        )
    }

    return (
        <Box>
            <div className={classes.settingContainer}>
                <div style={{flex: 1, borderRightWidth: 1, borderRightColor: 'black'}}>
                    <List component='nav'>
                        {_.map(configs, (setting, index)=>(
                            <ListItem 
                                key={`settings-${index}`} 
                                button
                                selected={selectedCategory === setting.id}
                                onClick={()=>{setSelectedCategory(setting.id)}}
                            >
                                <ListItemIcon>
                                    {setting.icon}
                                </ListItemIcon>
                                <ListItemText primary={t(setting.primary)} secondary={setting.secondary}/>
                            </ListItem>
                        ))}
                    </List>
                </div>
                <div style={{flex: 2, height: 600}}>
                    {getContent(selectedCategory)}
                </div>
            </div>
        </Box>
    )
}

export default Settings